import clsx from 'clsx';
import Xicon from '@/assets/icons/x.svg';

interface ChipProps {
  label: string;
  className?: string;
  withClose?: boolean;
  onClose?: () => void;
}

export default function Chip({ label, className, withClose = false, onClose }: ChipProps) {
  return (
    <div
      className={clsx(
        'relative flex select-none items-center whitespace-nowrap rounded-xl bg-brand-50 py-1 px-3 font-sans text-xs font-medium text-brand-600 dark:bg-brand-500/10 dark:text-brand-400',
        className
      )}
    >
      <span>{label}</span>
      {withClose && onClose && (
        <button
          onClick={(event) => {
            event.preventDefault();
            onClose();
          }}
          aria-label={`Remove ${label}`}
          className="ml-2 p-0.5 flex items-center justify-center rounded-full hover:bg-brand-200 dark:hover:bg-brand-500/30 transition-colors text-brand-600 dark:text-brand-400"
        >
          <Xicon className="w-3 h-3" />
        </button>
      )}
    </div>
  );
}
